import merge from 'deepmerge';
import handleWithExpandedError from './handleWithExpandedErrors';

const withExpandedError = (procedureObject) => ({
  ...procedureObject,
  call: (...args) => procedureObject.call(merge.all([...args, { handleResponse: false }]))
    .then(handleWithExpandedError),
});

export default withExpandedError;
